import Vue from 'vue'
let EventBus = new Vue()

Vue.use((Vue, options) => Vue.prototype.$eventBus = EventBus)

export default ({app}) => {
  app.$eventBus = EventBus
}